module.exports = __webpack_public_path__ + "img/collection-engagementRingsPlatinum.34a9c0b.jpg";